module.exports = __webpack_public_path__ + "img/pix.013c3900.png";